document.addEventListener("DOMContentLoaded", function () {  
  const banner = document.getElementById("drop-sale-banner");
  if (!banner) return;

  const start = parseInt(banner.dataset.start) * 1000;
  const end = parseInt(banner.dataset.end) * 1000;

  const timerEl = document.getElementById("drop-sale-timer");

  function updateTimer() {
    const now = new Date().getTime();
    if (now < start) {
      banner.style.display = "none";
      return;
    }
    if (now > end) {
      banner.style.display = "none";
      return;
    }
    banner.style.display = "block";
    const distance = end - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((distance / (1000 * 60)) % 60);
    const seconds = Math.floor((distance / 1000) % 60);
    timerEl.innerHTML =
      `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }
  updateTimer();
  setInterval(updateTimer, 1000);
});